import * as React from 'react';

import { CalendarDate } from '@internationalized/date';
import {
  Button,
  DatePicker,
  DateValue,
  Popover,
  PopoverTrigger,
} from '@rematter/ui-web';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

export interface Props {
  onMarkAsReceived: (receivedDate: CalendarDate | undefined) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  receivedDate?: CalendarDate | undefined;
  popoverPlacement?: 'top' | 'bottom';
}

export const LoadStatusTransitionMarkAsReceivedButton: React.FC<Props> = ({
  onMarkAsReceived,
  isLoading,
  isDisabled,
  receivedDate: initialReceivedDate,
  // popoverPlacement = 'bottom',
}) => {
  const t = useTranslations();
  const [_open, setOpen] = React.useState(false);
  const [receivedDate, setReceivedDate] = React.useState<DateValue | null>(
    null,
  );

  React.useEffect(() => {
    if (initialReceivedDate) {
      setReceivedDate(initialReceivedDate);
    }
  }, [initialReceivedDate]);

  const handleDiscard = React.useCallback(() => {
    setReceivedDate(null);
    setOpen(false);
  }, []);

  return (
    <PopoverTrigger>
      <Button
        variant="solid"
        isLoading={isLoading}
        isDisabled={isDisabled}
        onPress={() => setOpen((v) => !v)}
      >
        {t.loadStatusTransition.markAsReceivedPopover.markAsReceived}
      </Button>
      <Popover isOpen={_open} onOpenChange={setOpen}>
        <div className="flex w-[320px] flex-col gap-4 rounded-md bg-white p-4 shadow-lg">
          <DatePicker
            value={receivedDate}
            onChange={setReceivedDate}
            className="w-full"
            label={t.loadStatusTransition.markAsReceivedPopover.receivedDate}
            isRequired={true}
            isDisabled={false}
          />
          <div className="mt-2 flex justify-end gap-2">
            <Button variant="outline" type="reset" onPress={handleDiscard}>
              {t.loadStatusTransition.markAsReceivedPopover.discard}
            </Button>
            <Button
              variant="solid"
              onPress={() => {
                setOpen(false);
                onMarkAsReceived(
                  receivedDate
                    ? new CalendarDate(
                        receivedDate.year,
                        receivedDate.month,
                        receivedDate.day,
                      )
                    : undefined,
                );
              }}
              isLoading={isLoading}
            >
              {t.loadStatusTransition.markAsReceivedPopover.markAsReceived}
            </Button>
          </div>
        </div>
      </Popover>
    </PopoverTrigger>
  );
};
